import { useEffect } from 'react'
import { Routes, Route, Navigate, useParams, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  supportedLanguages,
  defaultLanguage,
  type SupportedLanguage,
} from '@/i18n'

export function LanguageWrapper() {
  const { lang } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()

  useEffect(() => {
    if (lang && supportedLanguages.includes(lang as SupportedLanguage)) {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang)
      }
    }
  }, [lang, i18n])

  // Redirect invalid language to default
  if (!lang || !supportedLanguages.includes(lang as SupportedLanguage)) {
    return <Navigate to={`/${defaultLanguage}`} replace />
  }

  return <Outlet />
}

export function LanguageRouter() {
  return (
    <Routes>
      {/* Redirect root to default language */}
      <Route path="/" element={<Navigate to={`/${defaultLanguage}`} replace />} />

      {/* Language-prefixed routes */}
      <Route path="/:lang/*" element={<LanguageWrapper />} />
    </Routes>
  )
}
